export const STAGE_TAG = 'stage-tag';

export const GROUP_PROFILE_BTN_TEST_ID = 'group-profile-btn-test-id';
export const CHECKLIST_STEPS_SECTION_TEST_ID = 'checklist-steps-section-test-id';
export const CHECKLIST_STEPS_SKELETON_TEST_ID = 'checklist-steps-skeleton-test-id';

export const GROUP_INFO_BLOB_TEST_ID = 'group-info-blob-test-id';
